registerComponent("templates/header", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Além do que já morava aqui (menu, submenu de produtos, seletor de idioma e
 * a busca), este arquivo recebeu o bloco `is-scrolled` que vivia no
 * `legacy-main.js` — o preloader que o disparava (`preloaded.after`) saiu na
 * Fase 2, e o header que gruda no topo é comportamento do header.
 *
 * ⚠️ O DEGRAU AQUI É 767, NÃO 768. `Asa.legado.celular` é o `@legacy-maxSm` do
 * LESS deste componente; `Asa.celular` é o do DS e trocaria de modo um pixel
 * antes da folha.
 */

const wrapperMenu = component.querySelector('.wrapper-menu');
const btnMenu = component.querySelector('.btn-menu');
const mainMenu = component.querySelector('.main-menu');
const menuLabel = btnMenu ? btnMenu.querySelector('.menu-label') : null;
const linksToSub = component.querySelectorAll('.link-to-sub');
const productsMenu = component.querySelector('.products-menu');
const submenuTitles = component.querySelectorAll('.submenu-title');
const subLists = component.querySelectorAll('.submenu ul');
const productSubmenus = component.querySelectorAll('.product-submenu');

const modalFaq = document.querySelector('[data-component-name="modals/modal-faq"]');
const btnsOpenModalFaq = component.querySelectorAll('[data-open-modal-faq]');

const toggleSearch = component.querySelector('.toggle-search');
const searchForm = component.querySelector('.search-box');
const btnCloseSearch = component.querySelector('.btn-close-search');
const cleanSearch = component.querySelector('.clean-search');
const inputSearch = searchForm ? searchForm.querySelector('input') : null;

const btnLang = component.querySelector('.btn-language-sub');
const subLang = component.querySelector('.sub-language');
const mainHeader = component.querySelector('.main-header');

const menuControl = {
    opened: false,
    labelfalse: () => 'Menu',
    labeltrue: () => (btnMenu ? btnMenu.dataset.closeLabel : ''),
};

/*
 | O `data('back')` de 2020. O jQuery guardava isto no store dele, NÃO no
 | atributo — é por isso que aqui é uma variável e não `dataset.back`: escrever
 | `data-back` no DOM seria markup que o baseline não tem. O `aria-back`, que a
 | folha lê em `[aria-back="true"]`, continua indo para o atributo.
 */
let menuVoltar = false;

const toggleMenu = (close = false) => {
    if (close) {
        menuControl.opened = false;
    } else {
        menuControl.opened = !menuControl.opened;
    }

    if (Asa.legado.celular.matches) {
        document.body.classList.toggle('modal-opened', menuControl.opened);
        document.body.classList.toggle('menu-opened', menuControl.opened);
    }

    if (btnMenu) {
        btnMenu.setAttribute('aria-expanded', String(menuControl.opened));
    }

    if (wrapperMenu) {
        wrapperMenu.setAttribute('data-show', String(menuControl.opened));
    }

    component.setAttribute('data-show', String(menuControl.opened));

    if (menuLabel) {
        menuLabel.textContent = menuControl['label' + menuControl.opened]();
    }
};

btnsOpenModalFaq.forEach(function (botao) {
    botao.addEventListener('click', function () {
        toggleMenu(true);

        if (modalFaq) {
            modalFaq.dispatchEvent(new CustomEvent('open'));
        }
    });
});

if (btnMenu) {
    btnMenu.addEventListener('click', function () {
        if (menuVoltar && Asa.legado.celular.matches) {
            menuVoltar = false;
            btnMenu.setAttribute('aria-back', 'false');

            productSubmenus.forEach((el) => el.classList.remove('active'));
            linksToSub.forEach((el) => el.classList.remove('active'));

            if (mainMenu) {
                mainMenu.classList.remove('active');
            }

            return;
        }

        toggleMenu();
    });
}

/*
 | 2020 escolhia UM evento no carregamento (`wW <= 768 ? 'click' : 'mouseover'`)
 | e nunca mais o revia: uma janela redimensionada ficava com o evento errado.
 | Aqui os dois ficam ligados e quem decide é a guarda, com o mesmo degrau do
 | LESS — em qualquer largura fixa o comportamento é o de 2020, e a travessia
 | deixou de prender o menu.
 */
linksToSub.forEach(function (link) {
    link.addEventListener('click', function () {
        if (Asa.legado.celular.matches) {
            abrirSubmenu(link);
        }
    });

    link.addEventListener('mouseover', function () {
        if (!Asa.legado.celular.matches) {
            abrirSubmenu(link);
        }
    });
});

submenuTitles.forEach(function (titulo) {
    titulo.addEventListener('click', function () {
        subLists.forEach((el) => el.classList.remove('active'));

        if (titulo.nextElementSibling) {
            titulo.nextElementSibling.classList.add('active');
        }
    });
});

if (btnLang) {
    btnLang.addEventListener('click', function () {
        if (subLang) {
            subLang.classList.toggle('show');
        }

        if (mainHeader) {
            mainHeader.classList.toggle('show-sub-language');
        }
    });
}

document.body.addEventListener('click', function (event) {
    const dentroDoHeader = event.target instanceof Element
        && event.target.closest('[data-component-name="templates/header"]');

    if (subLang && subLang.classList.contains('show') && !dentroDoHeader) {
        subLang.classList.remove('show');

        if (mainHeader) {
            mainHeader.classList.remove('show-sub-language');
        }
    }
});

/*
 | O `.toggle-search` está COMENTADO no Blade desde antes do baseline, então
 | quem abria a busca do header não existe e o formulário nunca fica
 | `.is-active`. O fechar continua ligado, como em 2020, e a guarda do
 | `toggleSearch` é o que separa "sem call site" de TypeError no clique.
 */
if (btnCloseSearch) {
    btnCloseSearch.addEventListener('click', function (event) {
        event.preventDefault();

        if (inputSearch) {
            inputSearch.value = '';
        }

        if (cleanSearch) {
            cleanSearch.classList.remove('is-active');
        }

        if (toggleSearch) {
            toggleSearch.classList.remove('is-active');
        }

        if (searchForm) {
            searchForm.classList.remove('is-active');
        }
    });
}

/* =========================================================================
   O HEADER QUE GRUDA NO TOPO — era o bloco `preloaded.after` do legacy-main.js
   ====================================================================== */

const hero = document.querySelector('[data-component-name="sections/hero"]');
const footer = document.querySelector('[data-component-name="templates/footer"]');

let footerNaTela = false;
let preso = false;

/*
 | O `!$footer.isOnScreen(0)` de 2020 é exatamente "a caixa do rodapé não
 | cruza a viewport" — o plugin comparava as mesmas duas bordas que o
 | IntersectionObserver com threshold 0.
 */
if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
        footerNaTela = entradas[0].isIntersecting;

        conferirTopo(window.scrollY);
    }).observe(footer);
}

Asa.aoRolar(function (y) {
    /*
     | `btnMenu.click()` e não `toggleMenu(true)`: era `$btnMenu.trigger('click')`
     | em 2020, e o handler do botão tem o desvio do "voltar" — com um submenu
     | aberto no celular, rolar volta um nível em vez de fechar o menu.
     */
    if (menuControl.opened && btnMenu) {
        btnMenu.click();
    }

    conferirTopo(y);
});

/**
 * @param {number} y
 */
function conferirTopo(y) {
    if (!hero) {
        return;
    }

    const deveriaPrender = y > alturaDoHero() && !footerNaTela;

    if (deveriaPrender === preso) {
        return;
    }

    preso = deveriaPrender;

    if (!deveriaPrender) {
        component.classList.remove('is-scrolled');

        return;
    }

    component.classList.add('is-scrolled');

    /*
     | A entrada de cima que era `TweenLite.fromTo(y: '-100%' → '0%')`. Com o
     | menu aberto (`data-show="true"`) 2020 não animava, e aqui também não.
     | O padrão é o de `Asa.revelar`: pinta o estado "antes", tira no quadro
     | seguinte, e um `setTimeout` de reserva para a aba em segundo plano,
     | onde `requestAnimationFrame` não dispara e o header ficaria escondido
     | acima da dobra.
     */
    if (component.getAttribute('data-show') === 'true' || !Asa.movimentoPermitido()) {
        return;
    }

    component.classList.add('is-entrando');

    const descer = () => component.classList.remove('is-entrando');

    requestAnimationFrame(() => requestAnimationFrame(descer));
    setTimeout(descer, Asa.ESPERA_MAXIMA);
}

/**
 * A altura do hero como o `.height()` do jQuery a media: caixa de conteúdo,
 * sem padding nem borda.
 *
 * @returns {number}
 */
function alturaDoHero() {
    const estilo = getComputedStyle(hero);

    return hero.clientHeight
        - (parseFloat(estilo.paddingTop) || 0)
        - (parseFloat(estilo.paddingBottom) || 0);
}

/**
 * @param {Element} link
 */
function abrirSubmenu(link) {
    const id = link.getAttribute('aria-controls');

    if (Asa.legado.celular.matches && btnMenu) {
        menuVoltar = true;
        btnMenu.setAttribute('aria-back', 'true');
    }

    productSubmenus.forEach((el) => el.classList.remove('active'));
    linksToSub.forEach((el) => el.classList.remove('active'));

    if (mainMenu) {
        mainMenu.classList.add('active');
    }

    link.classList.add('active');

    const alvo = id && productsMenu ? productsMenu.querySelector(`#${CSS.escape(id)}`) : null;

    if (alvo) {
        alvo.classList.add('active');
    }
}

});
